module.exports = __webpack_public_path__ + "static/media/RecomendaPascoa.27be3f0f.jpg";